import { FAIcon } from '@/components/fa-icon'

interface Props {
  label: string
  onActivate(): void
}

export const AddTagButton: React.FC<Props> = ({ label, onActivate }) => (
  <span
    role="button"
    tabIndex={0}
    aria-label={label}
    title={label}
    onClick={evt => {
      evt.stopPropagation()
      evt.preventDefault()
      onActivate()
    }}
    onKeyDown={evt => {
      if (evt.key === 'Enter' || evt.key === ' ') {
        evt.stopPropagation()
        evt.preventDefault()
        onActivate()
      }
    }}
    className="ml-auto inline-flex items-center justify-center size-6 rounded-full text-gray-500 hover:text-secondary hover:bg-gray-100 cursor-pointer"
  >
    <FAIcon icon="plus" />
  </span>
)
